import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Label } from '../../classes/label';
import { LabelService } from '../../pages/labels/label.service';
import { NotificationService } from '../../shared/services/notification.service';
import { PremiitError } from '../../utils/premiit-error';
import { ResponseData } from '../../utils/response';
import * as labelsActions from '../actions/labels.actions';

@Injectable()
export class LabelsEffects {
  constructor(
    private action$: Actions,
    private labelService: LabelService,
    private notify: NotificationService,
    private router: Router
  ) {}

  public getLabelsEffect = createEffect(() =>
    this.action$.pipe(
      ofType(labelsActions.getLabelsAction),
      mergeMap(() =>
        this.labelService.findLabels().pipe(
          map((response: ResponseData<Label[]>) =>
            labelsActions.getLabelsSuccessAction({ labels: response.data })
          ),
          catchError((error: PremiitError) => of(labelsActions.getLabelsErrorAction({ error })))
        )
      )
    )
  );

  public createLabelEffect = createEffect(() =>
    this.action$.pipe(
      ofType(labelsActions.createLabelAction),
      mergeMap((action) =>
        this.labelService.createLabel(action.label).pipe(
          map((response: ResponseData<Label>) =>
            labelsActions.createLabelSuccessAction({ label: response.data })
          ),
          tap(() => {
            this.notify.success('Etiqueta registrada con éxito');
            this.router.navigate(['labels']);
          }),
          catchError((error: PremiitError) => {
            this.notify.customError(error);
            return of(labelsActions.createLabelErrorAction({ error }));
          })
        )
      )
    )
  );

  public updateLabelEffect = createEffect(() =>
    this.action$.pipe(
      ofType(labelsActions.updateLabelAction),
      mergeMap((action) =>
        this.labelService.updateLabel(action.label).pipe(
          map((response: ResponseData<Label>) =>
            labelsActions.updateLabelSuccessAction({ label: response.data })
          ),
          tap(() => {
            this.notify.success('La etiqueta se actualizó con éxito');
            this.router.navigate(['labels']);
          }),
          catchError((error: PremiitError) => {
            this.notify.customError(error);
            return of(labelsActions.updateLabelErrorAction({ error }));
          })
        )
      )
    )
  );

  public deleteLabelEffect = createEffect(() =>
    this.action$.pipe(
      ofType(labelsActions.deleteLabelAction),
      mergeMap((action) =>
        this.labelService.deleteLabel(action.label).pipe(
          map(() => labelsActions.deleteLabelSuccessAction({ label: action.label })),
          tap(() => this.notify.success('Etiqueta eliminada')),
          catchError((error: PremiitError) => {
            this.notify.customError(error);
            return of(labelsActions.deleteLabelError({ error }));
          })
        )
      )
    )
  );
}
